import instance from './instance';

export const fetchGoals = params => instance.get('/goals', { params });

export const fetchSingleGoal = slug => instance.get(`/goals/${slug}`);

export const createGoal = data => instance.post('/goals', data);

export const createGoalV2 = data => instance.post('/goals/v2_create', data);

export const updateGoal = data => instance.put(`/goals/${data.goal.slug}`, data);

export const deleteGoal = slug => instance.delete(`/goals/${slug}`);

export const moveGoal = goals => instance.post('/goals/move', { goals });

export const changeGoalCompleteness = (slug, data) => instance.put(`/goals/${slug}`, data);

export const changeStatus = (slug, status) => instance.put(`/goals/${slug}`, { status });

export const saveActionItemOrder = (slug, data) => instance.post(`/goals/${slug}/drop_items`, data);

export const exportGoals = params => instance.get('/goals/export_goals', { params });

export const updateParentGoal = data => instance.put(`/goals/${data.goal.slug}/update_parent_goal`, data);

export const createSuggestedSubgoalsOrActionItems = ({ slug, suggested_object_type }) =>
  instance.post(`/goals/${slug}/create_ai_suggested_subgoals_or_action_items`, { suggested_object_type });
